// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import injector from 'vue-inject'
import { Events } from '@/core/Events'
import { Spotify } from '@/core/Spotify'
import vueSmoothScroll from 'vue-smooth-scroll'
import VueLocalStorage from 'vue-localstorage'
import MobileDetect from 'mobile-detect'
const { detect } = require('detect-browser')

Vue.use(VueLocalStorage, { name: 'storage' })
Vue.use(injector)
Vue.use(vueSmoothScroll)

Vue.config.productionTip = false

let spotifyReady = false
let spotifyPaused = true
let spotifyFollow = null
let spotifyPlaylist = null
let spotifyTrackIndex = null
let spotifyCurrentTrack = null
let spotifyTrackPosition = null

Object.defineProperties(Vue.prototype, {
  $bus: {
    get () {
      return Events
    }
  },
  $spotify: {
    get () {
      let s = Spotify
      s.setAccessToken(this.$storage.get('spotifyAccessToken'))
      return s
    }
  },
  $browser: {
    get () {
      return detect
    }
  },
  $mobileDetect: {
    get () {
      return new MobileDetect(window.navigator.userAgent)
    }
  },
  $spotifyReady: {
    get () {
      return spotifyReady
    },
    set (status) {
      spotifyReady = status
    }
  },
  $spotifyCurrentTrack: {
    get () {
      return spotifyCurrentTrack
    },
    set (track) {
      spotifyCurrentTrack = track
      this.$bus.$emit('spotify-player-current', track)
    }
  },
  $spotifyPaused: {
    get () {
      return spotifyPaused
    },
    set (status) {
      spotifyPaused = status
      this.$bus.$emit('spotify-player-paused', status)
    }
  },
  $spotifyFollow: {
    get () {
      if (spotifyFollow === null) {
        spotifyFollow = this.$storage.get('spotifyFollow', '0')
      }
      return spotifyFollow
    },
    set (status) {
      spotifyFollow = status
      this.$storage.set('spotifyFollow', ((status) ? '1' : '0'))
    }
  },
  $spotifyPlaylist: {
    get () {
      return spotifyPlaylist
    },
    set (playlist) {
      this.$bus.$emit('spotify-player-playlist', playlist)
      spotifyPlaylist = playlist
    }
  },
  $spotifyTrackIndex: {
    get () {
      if (spotifyTrackIndex === null) {
        spotifyTrackIndex = this.$storage.get('spotifyTrackIndex', 0)
      }
      return spotifyTrackIndex
    },
    set (index) {
      this.$storage.set('spotifyTrackIndex', index)
      this.$bus.$emit('spotify-player-index', index)
      spotifyTrackIndex = index
    }
  },
  $spotifyTrackPosition: {
    get () {
      if (spotifyTrackPosition === null) {
        spotifyTrackPosition = this.$storage.get('spotifyTrackPosition', 0)
      }
      return spotifyTrackPosition
    },
    set (index) {
      this.$storage.set('spotifyTrackPosition', index)
      spotifyTrackPosition = index
    }
  }
})

/* eslint-disable no-new */
new Vue({
  localStorage: {
    spotifyAccessToken: {
      type: String
    },
    spotifyState: {
      type: String
    },
    spotifyTokenExpiresIn: {
      type: Number
    }
  },
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js